import React, { useEffect } from 'react';
import $ from 'jquery';
import '../particles-js/particles.css';


const Header = () => {
  useEffect(() => {
    $('body').append('<script src="./js/particles-js/app.js" title="particles.app"></script>')
    return () => {
      document.body.removeChild(document.querySelector('[title="particles.app"]'))
    };
  }, []);
  return (
    <header >
        <section id="home" className="header d-block">
          <div id="particles-js"></div>
          <div className="header-top d-flex justify-content-center align-items-center mx-auto">
            <h1 className="display-2">I<span>'</span>M
            <br /> SAID
            <br /> NASSER
            <span>.</span>
              <br /><span className="h4 font-weight-lighter engineer">FRONT-END ENGINEER</span>
            </h1>
          </div>
          <div className="header-bottom text-centerr mx-auto">
            <img src="./images/logo.png" width="64px;" alt="logo" className="d-block mx-auto mb-3" />
            <p>

              From the moment I produced "hello world" in the console of my first application, I knew I was hooked into the world of
              software development. But software development has never been "just a job" for me, it's offered an engaging challenge to
              continually learn and improve my skills in creating high-quality software. what started with a simple "hello world" has
              become a full-fledged passion that only gets more exciting as time goes by.
                <br />
                I have a bachelor of Engineering - Computer Science - BE at Faculty of Electronic Engineering, Menoufia University.
                <br />
                I’m a Front End Engineer with good experience in developing web apps, started from designing html prototypes, visual
                interfaces and interaction of web-based applications.
                I implement the user interface design, work with the product development team to design online user experience, ensure
                user experience is formulated to achieve the goals of the online entity.
            </p>
          </div>
        </section>
      </header>
  );
}

export default Header;
